import { publicClient, privateClient } from "../../configs/axiosConfig";

const bookingEndpoints = {
  createBooking: "v2/booking",
  getAllBookings: "v2/booking",
  getBookingById: "v2/booking/:id",
  getBookingByStaffId: "v2/booking/staff/:id",
  deleteBookingById: "v2/booking/delete/:id",
  deleteAllBookings: "v2/booking/deleteAll",
  getBookingsByUserAndIds: "v2/booking/user-bookings", // NEW endpoint
  getBookingsByUserId: "v2/booking/user/:id",
  getAvailableTimeslot: (professionalId, date) =>
    `v2/booking/available-timeslots?professionalId=${professionalId}&date=${date}`,
  cancelBooking: "v2/booking/:id/cancel",
  reactiveBooking: "v2/booking/reactivate/:id",
  updateBooking: "v2/booking/:id", // reuse the same endpoint as get/delete
};

const bookingApi = {
  // Create a booking
  createBooking: async (payload) => {
    try {
      const response = await privateClient.post(
        bookingEndpoints.createBooking,
        payload
      );
      return { response };
    } catch (err) {
      console.error("Error creating booking:", err);
      return { err };
    }
  },

  // Get all bookings
  getAllBookings: async () => {
    try {
      const response = await privateClient.get(bookingEndpoints.getAllBookings);
      return { response };
    } catch (err) {
      console.error("Error fetching bookings:", err);
      return { err };
    }
  },

  // Get bookings by userId and bookingIds
  getBookingsByUserAndIds: async ({ userId, bookingIds }) => {
    try {
      const response = await privateClient.get(
        bookingEndpoints.getBookingsByUserAndIds,
        {
          params: {
            userId,
            bookingIds: bookingIds.join(","), // send as comma-separated list
          },
        }
      );
      return { response };
    } catch (err) {
      console.error("Error fetching user bookings:", err);
      return { err };
    }
  },

  // Get a booking by ID
  getBookingById: async ({ id }) => {
    try {
      const endpoint = bookingEndpoints.getBookingById.replace(":id", id);
      const response = await privateClient.get(endpoint);
      return { response };
    } catch (err) {
      console.error("Error fetching booking detail:", err);
      return { err };
    }
  },

  getBookingByStaffId: async ({ id }) => {
    try {
      const endpoint = bookingEndpoints.getBookingByStaffId.replace(":id", id);
      const response = await privateClient.get(endpoint);
      return { response };
    } catch (err) {
      console.error("Error fetching booking detail:", err);
      return { err };
    }
  },
  // Delete a booking by userID

  getBookingsByUserId: async (userId) => {
    try {
      const endpoint = bookingEndpoints.getBookingsByUserId.replace(
        ":id",
        userId
      );
      const response = await privateClient.get(endpoint);
      return { response };
    } catch (err) {
      console.error("Error fetching bookings by user ID:", err);
      return { err };
    }
  },

  // Delete a booking by ID
  deleteBookingById: async ({ _id }) => {
    try {
      const endpoint = bookingEndpoints.deleteBookingById.replace(":id", _id);
      const response = await privateClient.post(endpoint);
      return { response };
    } catch (err) {
      console.error("Error deleting booking:", err);
      return { err };
    }
  },

  // Delete all bookings
  deleteAllBookings: async () => {
    try {
      const response = await privateClient.delete(
        bookingEndpoints.deleteAllBookings
      );
      return { response };
    } catch (err) {
      console.error("Error deleting all bookings:", err);
      return { err };
    }
  },

  //get available timeslot
  getAvailableTimeslot: async (professionalId, date) => {
    try {
      const url = bookingEndpoints.getAvailableTimeslot(professionalId, date);
      const response = await privateClient.get(url);
      return { response };
    } catch (err) {
      console.error("Error fetching bookings:", err);
      return { err };
    }
  },

  // cancel booking
  cancelBooking: async ({ id }) => {
    try {
      const endpoint = bookingEndpoints.cancelBooking.replace(":id", id);
      const response = await privateClient.patch(endpoint); // PATCH method
      return { response };
    } catch (err) {
      console.error("Error canceling booking:", err);
      return { err };
    }
  },
  // reactive booking

  reactivateBooking: async ({ id }) => {
    try {
      const endpoint = bookingEndpoints.reactiveBooking.replace(":id", id);
      const response = await privateClient.put(endpoint);
      return { response };
    } catch (err) {
      console.error("Error reactivating booking:", err);
      return { err };
    }
  },

  //update booking
  updateBooking: async (id, payload) => {
    try {
      const endpoint = bookingEndpoints.updateBooking.replace(":id", id);
      const response = await privateClient.patch(endpoint, payload);
      return { response };
    } catch (err) {
      console.error("Error updating booking:", err);
      return { err };
    }
  },
};

export default bookingApi;
